import ChipButton from '@ui/elements/ChipButton'
import { formatVbox } from './vbox'

/** Technical token — the same in every language, so it is not translated. */
const LABEL = 'VBOX'
const EMPTY_VALUE = '—'

interface Props {
  vboxMm?: number
  disabled?: boolean
  onPress: () => void
}

/** Chip showing the lens height the measurement runs with; opens the modal. */
export default function Button({ vboxMm, disabled, onPress }: Props) {
  return (
    <ChipButton
      label={LABEL}
      value={formatVbox(vboxMm) || EMPTY_VALUE}
      disabled={disabled}
      onPress={onPress}
    />
  )
}
